/* eslint-disable import/order */
import { globalSettingsIssueFieldsManagementRouteEntryPoint } from '@jira/admin-pages__fields-page/src/globalSettingsIssueFieldsManagementRouteEntryPoint.entrypoint.tsx';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalSettingsIssueFieldsManagementRoute } from '@jira/router-routes__admin-pages-fields-routes/src/globalSettingsIssueFieldsManagementRoute.tsx';
import { conditionalPostOfficeJiraTopBannerResource } from '@jira/router-resources__post-office/src/conditionalPostOfficeJiraTopBannerResource.tsx';
import type { Route } from '@atlassian/react-resource-router';

const globalSettingsIssueFieldsManagementEntryPointPage = createPageEntryPoint({
	main: globalSettingsIssueFieldsManagementRouteEntryPoint,
});

export const globalSettingsIssueFieldsManagementRouteEntry: Route = createEntry(
	globalSettingsIssueFieldsManagementRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'global-admin.issues.fields',
		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
			menuId: MenuIdSettings,
		},

		canTransitionIn: () => true,

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			conditionalPostOfficeJiraTopBannerResource,
		],

		entryPoint() {
			return globalSettingsIssueFieldsManagementEntryPointPage;
		},

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
